module.exports = __webpack_public_path__ + "img/049-tunisia.881e1b1c.svg";